import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/AppShell.jsx';
import Landing from './pages/Landing.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Inventory from './pages/Inventory.jsx';
import Report from './pages/Report.jsx';
import Pricing from './pages/Pricing.jsx';

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/"          element={<Landing  />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/report"    element={<Report    />} />
        <Route path="/pricing"   element={<Pricing   />} />
        <Route path="*"          element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
